import { LogEvent } from 'src/app/interfaces/log'
import { EventLoggingParams, LogEventKey } from '../../../interfaces/log'
import { LogService } from '../log.service'
import { QuizReportType } from '../../../interfaces/quiz';

export class IdealTypeLogService {
  constructor(private logService: LogService) { }

  idealTypeResultIdealTypeButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_RESULT_IDEAL_TYPE_BUTTON_CLICKED)
  }

  idealTypeResultMbtIButtonViewed(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_RESULT_MBTI_BUTTON_VIEWED)
  }

  idealTypeRankClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_RANK_CLICKED)
  }

  idealTypeResultMbtIButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_RESULT_MBTI_BUTTON_CLICKED)
  }

  idealTypeResultShareButtonClicked(type: 'kakao' | 'copy'): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_RESULT_SHARE_BUTTON_CLICKED, { type })
  }

  idealTypeResultQrCodeButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_RESULT_QR_CODE_BUTTON_CLICKED)
  }

  idealTypeResultResultScreenViewed(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_RESULT_RESULT_SCREEN_VIEWED)
  }

  idealTypeResultMbtiQuizButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_RESULT_MBTI_QUIZ_BUTTON_CLICKED)
  }

  idealTypeMatchScreenViewed(type: 'host' | 'guest'): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_MATCH_SCREEN_VIEWED, { type })
  }
  idealTypeMatchFloatingBannerClicked(type: 'host' | 'guest'): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_MATCH_FLOATING_BANNER_CLICKED, { type })
  }

  idealTypeQuestionnaireScreenViewed(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUSTIONNAIRE_SCREEN_VIEWED)
  }

  idealTypeIntroScreenViewed(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_INTRO_SCREEN_VIEWED)
  }

  idealTypeChemiButtonClicked(type: 'host' | 'guest'): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_CHEMI_BUTTON_CLICKED, { type })
  }

  idealTypeGuestIntroScreenViewed(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_GUEST_INTRO_SCREEN_VIEWED)
  }

  idealTypeGuestMbtIChooseScreenViewed(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_GUEST_MBTI_CHOOSE_SCREEN_VIEWED)
  }

  idealTypeGuestMbtiChose(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_GUEST_MBTI_CHOSE)
  }

  idealTypeGuestMbtINeededScreenViewed(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_GUEST_MBTI_NEEDED_SCREEN_VIEWED)
  }

  idealTypeGuestMbtIButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_GUEST_MBTI_BUTTON_CLICKED)
  }

  logHomeIdealTypeClicked(): void {
    this.eventLogging(LogEvent.HOME_SOCIAL_CONTENT_CLICKED)
  }

  logIdealTypeResultViewCompatibilityBannerClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_RESULT_VIEW_COMPATIBILITY_BANNER_CLICKED)
  }

  logIdealTypeResultHomeButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_RESULT_HOME_BUTTON_CLICKED)
  }

  logGuestNewMbtiButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_GUEST_NEW_MBTI_BUTTON_CLICKED)
  }

  logIdealTypeCreateSubmit(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_CREATE_SUBMIT)
  }
  idealTypeMatchIdealTypeQuizButtonClicked(type: 'description' | 'footer'): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_MATCH_IDEAL_TYPE_QUIZ_BUTTON_CLICKED, { type })
  }
  idealTypeBackToResultButton(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_BACK_TO_RESULT_BUTTON_CLICKED)
  }
  idealTypeDatingStyleButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_RESULT_DATING_STYLE_BUTTON_CLICKED);
  }

  idealTypeCharacterChangeButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_CHARACTER_CHANGE_BUTTON_CLICKED)
  }

  showAllRankingButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_RESULT_SHOW_ALL_RANKING_BUTTON_CLICKED)
  }

  resultMyMbtiChangeButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_RESULT_MY_MBTI_CHANGE_BUTTON_CLICKED)
  }
  resultFloatingBannerClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_RESULT_FLOATING_BANNER_CLICKED)
  }

  idealTypeSelectViewed(): void {
    const from = 'mbti_ideal_type'
    this.eventLogging(LogEvent.IDEAL_TYPE_SELECT_VIEWED, { from })
  }

  idealTypeSelectCardClicked(type?: QuizReportType): void {
    const from = 'mbti_ideal_type'
    this.eventLogging(LogEvent.IDEAL_TYPE_SELECT_CARD_CLICKED, { type, from })
  }

  idealTypeSelectCreateNewClicked(): void {
    const from = 'mbti_ideal_type'
    this.eventLogging(LogEvent.IDEAL_TYPE_SELECT_CREATE_NEW_CLICKED, { from })
  }

  private eventLogging(event: LogEventKey, params?: EventLoggingParams): void {
    this.logService.eventLogging(event, {
      ...params,
    })
  }
}
